import React from 'react';
import { Stack, WrapItem } from '@fiverr-private/layout_components';
import { useTagsContext } from '../TagsContext/TagsContext';

export const TagItemWrapper: React.FC = ({ children }) => {
    const { tagsLayout } = useTagsContext();

    return (
        <WrapItem>
            <Stack wrap="nowrap" gap={tagsLayout.gap}>
                {children}
            </Stack>
        </WrapItem>
    );
};
